var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconSend(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.05c.01-.718-.406-1.377-1.082-1.722L5.173 2.252a2.18 2.18 0 00-2.201.097c-.677.431-1.023 1.456-.834 2.197l1.47 5.749c.15.59.716 1.004 1.366 1.002l8.762-.026c.449-.008.813.332.804.75-.002.412-.36.747-.809.755l-8.77.02c-.65 0-1.218.417-1.373 1.008l-1.522 5.771c-.185.682.026 1.363.541 1.844.061.057.13.12.198.17.667.48 1.541.542 2.288.171l15.799-7.997c.677-.335 1.098-.996 1.108-1.713z",
    fill: "#BDBDBD"
  })));
}

export default SvgIconSend;